const _ = require('lodash');

module.exports = (left
/*: Array<any>*/
, right
/*: Array<any>*/
, iteratee
/*: Function | string*/
) => ({
  left: _.differenceBy(left, right, iteratee),
  right: _.differenceBy(right, left, iteratee)
});